import {
  GET_PERSONALIZATION,
  GET_PERSONALIZATION_SUCCESS,
  GET_PERSONALIZATION_ERROR,
} from "../../constants/action-types";
import { assignReturnToUrlForLinkUrls } from "../../util/url-utils";

export const personalizationInitialState = {
  isFetching: false,
};

export const reducer = (
  state = personalizationInitialState,
  { type, payload }
) => {
  switch (type) {
    case GET_PERSONALIZATION: {
      return {
        ...state,
        isFetching: true,
      };
    }
    case GET_PERSONALIZATION_SUCCESS: {
      if (payload?.userHeader?.linkURLs) {
        assignReturnToUrlForLinkUrls(payload.userHeader.linkURLs);
      }
      return {
        ...state,
        data: payload,
        isFetching: false,
      };
    }
    case GET_PERSONALIZATION_ERROR: {
      return {
        ...state,
        isFetching: false,
      };
    }
    default:
      return state;
  }
};
